/**
 * @fileoverview Header component.core
 *
 */
'use strict';
// React Import
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
// Library Import
import _ from 'lodash';
import mobiscroll from '../../lib/mobiscroll/forms.react';
import { os } from '../../lib/mobiscroll/util/platform';
// Core Import
import Loading from './Loading';
import HeaderMenu from '../core/HeaderMenu';
// Collection Import
import AuthenticationCollection from '../../collection/AuthenticationCollection';
// Util Import
import * as ConstUtil from '../../util/ConstUtil';

/**
 * ポータルヘッダーコンポーネント
 *
 * @class Header
 * @extends {Component}
 */
class Header extends Component {
  constructor(props) {
    super(props);
    this.collection = new AuthenticationCollection();
    _.bindAll(
      this,
      'clickMyPageButton',
      'clickHamburgerMenu',
      'logout',
      'getRefHeader'
    );
  }

  /**
   * Component 更新前処理
   *
   * @memberof Header
   */
  componentDidUpdate() {
    this.props.setHeight(this.refHeader.offsetHeight);
  }

  /**
   * ログアウト
   *
   * @memberof Header
   */
  logout() {
    Loading.show();
    this.collection.logout(
      {
        success: this.successLogout.bind(this),
        failure: this.failureLogout.bind(this)
      },
      {}
    );
  }

  /**
   * ログアウト成功
   *
   * @memberof Header
   */
  successLogout() {
    // ローカルストレージクリア
    localStorage.clear();
    Loading.hide();
    // ログイン画面に遷移
    this.props.history.push(ConstUtil.Common.COMPONENT.LOGIN.URL);
  }

  /**
   * ログアウト失敗
   *
   * @memberof Header
   */
  failureLogout(err) {
    Loading.hide();
    // レスポンスが存在しない場合
    if (_.isEmpty(err.response)) {
      // ローカルストレージクリア
      localStorage.clear();
      // ログイン画面遷移
      this.props.history.push(ConstUtil.Common.COMPONENT.LOGIN.URL);
      return;
    }
    // 認証エラーの場合
    if (
      err.response.status ===
      ConstUtil.Common.HTTP_STATUS_CODE_LIST.UNAUTHORIZED
    ) {
      // ローカルストレージクリア
      localStorage.clear();
      // ログイン画面遷移
      this.props.history.push(ConstUtil.Common.COMPONENT.LOGIN.URL);
      return;
    }
    // メッセージ画面に遷移
    ConstUtil.Common.COMPONENT.MESSAGE.URL +
      this.createQueryParam([
        {
          key: 'main',
          value: 'COMMON.ID701'
        }
      ]);
  }

  /**
   * ボタンクリック
   *
   * @memberof CenterHeader
   */
  clickMyPageButton() {
    this.props.history.push(ConstUtil.Common.COMPONENT.PORTAL_MY_PAGE.URL);
  }

  /**
   *  タイトル要素の描画
   *
   * @returns {Object} タイトル要素
   * @memberof Header
   */
  renderSystemTitle() {
    return <div className="system-title">{ConstUtil.Message.COMMON.ID001}</div>;
  }

  /**
   * ボタンエリア要素の描画
   *
   * @returns {Object} ボタンエリア要素
   * @memberof Header
   */
  renderButtonArea() {
    // 未ログインの場合
    if (
      _.isEmpty(localStorage.getItem(ConstUtil.Common.STORAGE_KEY.AUTHORITY_ID))
    ) {
      return;
    }
    if (window.location.hash === ConstUtil.Common.COMPONENT.LOGIN.URL) {
      return;
    }
    // Android と iOSの場合
    if (os === 'android' || os === 'ios') {
      return this.renderHamburgerMenu();
    }
    return (
      <div className="header-button-area">
        <mobiscroll.Button
          flat={true}
          icon="fa-user"
          onClick={this.clickMyPageButton}
        >
          {ConstUtil.Message.COMMON.ID002}
        </mobiscroll.Button>
        <mobiscroll.Button flat={true} icon="fa-sign-out" onClick={this.logout}>
          {ConstUtil.Message.COMMON.ID003}
        </mobiscroll.Button>
      </div>
    );
  }

  /**
   * メニュー要素の描画
   *
   * @returns {Object} メニュー要素
   * @memberof CenterHeader
   */
  renderMenu() {
    // 未ログインの場合
    if (this.props.location.hash === ConstUtil.Common.COMPONENT.LOGIN.URL) {
      return;
    }
    if (
      this.props.location.hash ===
      ConstUtil.Common.COMPONENT.ACCOUNT_PROVISIONAL_REGIST.URL
    ) {
      return;
    }
    if (
      !this.props.location.hash.indexOf(
        ConstUtil.Common.COMPONENT.ACCOUNT_REGIST.URL
      )
    ) {
      return;
    }
    if (
      this.props.location.hash ===
      ConstUtil.Common.COMPONENT.PASSWORD_REISSUE.URL
    ) {
      return;
    }
    return <HeaderMenu />;
  }

  /**
   * メニューアイテムクリック
   *
   * @param {object} event
   * @param {object} inst
   * @memberof Header
   */
  clickHamburgerMenu(event, inst) {
    // 選択を解除する
    inst.deselect(event.target);
    if (event.target.dataset.id === ConstUtil.Common.COMPONENT.LOGIN.URL) {
      this.logout();
      return;
    }
    this.props.history.push(event.target.dataset.id);
  }

  /**
   * ポータルトップのハンバーガーメニューを描画
   *
   * @returns {Object} ハンバーガーメニュー
   * @memberof Header
   */
  renderPortalTopMenu() {
    return (
      <mobiscroll.NavItem
        id={ConstUtil.Common.COMPONENT.PORTAL_TOP.URL}
        icon="fa-home"
      >
        {ConstUtil.Message.COMMON.ID101}
      </mobiscroll.NavItem>
    );
  }

  /**
   * マイページ画面のハンバーガーメニューを描画
   *
   * @returns {Object} ハンバーガーメニュー
   * @memberof Header
   */
  renderMyPageMenu() {
    return (
      <mobiscroll.NavItem
        id={ConstUtil.Common.COMPONENT.PORTAL_MY_PAGE.URL}
        icon="fa-user-circle-o"
      >
        {ConstUtil.Message.COMMON.ID002}
      </mobiscroll.NavItem>
    );
  }

  /**
   * ログアウトのハンバーガーメニューを描画
   *
   * @returns {Object} ハンバーガーメニュー
   * @memberof Header
   */
  renderLogoutMenu() {
    return (
      <mobiscroll.NavItem
        id={ConstUtil.Common.COMPONENT.LOGIN.URL}
        icon="fa-sign-out"
      >
        {ConstUtil.Message.COMMON.ID003}
      </mobiscroll.NavItem>
    );
  }

  /**
   * 車両一覧画面のハンバーガーメニューを描画
   *
   * @returns {Object} ハンバーガーメニュー
   * @memberof Header
   */
  renderCarListMenu() {
    return (
      <mobiscroll.NavItem
        id={ConstUtil.Common.COMPONENT.CAR_LIST.URL}
        icon="material-drive-eta"
      >
        {ConstUtil.Message.COMMON.ID102}
      </mobiscroll.NavItem>
    );
  }

  /**
   * ドライバー一覧画面のハンバーガーメニューを描画
   *
   * @returns {Object} ハンバーガーメニュー
   * @memberof Header
   */
  renderDriverListMenu() {
    return (
      <mobiscroll.NavItem
        id={ConstUtil.Common.COMPONENT.DRIVER_LIST.URL}
        icon="users"
      >
        {ConstUtil.Message.COMMON.ID103}
      </mobiscroll.NavItem>
    );
  }

  /**
   * 配送業者権限のメニューを描画
   *
   * @returns {Object} ハンバーガーメニュー
   * @memberof Header
   */
  renderContractorHamburgerMenu() {
    return (
      <div className="header-hamberger">
        <mobiscroll.HamburgerNav
          theme={ConstUtil.Common.THEME}
          lang={ConstUtil.Message.COMMON.ID401}
          onItemTap={this.clickHamburgerMenu}
        >
          {this.renderPortalTopMenu()}
          {this.renderCarListMenu()}
          {this.renderDriverListMenu()}
          {this.renderMyPageMenu()}
          {this.renderLogoutMenu()}
        </mobiscroll.HamburgerNav>
      </div>
    );
  }

  /**
   * ドライバー権限のメニューを描画
   *
   * @returns {Object} ハンバーガーメニュー
   * @memberof Header
   */
  renderDriverHamburgerMenu() {
    return (
      <div className="header-hamberger">
        <mobiscroll.HamburgerNav
          theme={ConstUtil.Common.THEME}
          lang={ConstUtil.Message.COMMON.ID401}
          onItemTap={this.clickHamburgerMenu}
        >
          {this.renderPortalTopMenu()}
          {this.renderMyPageMenu()}
          {this.renderLogoutMenu()}
        </mobiscroll.HamburgerNav>
      </div>
    );
  }

  /**
   * ハンバーガーメニュー描画
   *
   * @returns {Object} ハンバーガーメニュー
   * @memberof Header
   */
  renderHamburgerMenu() {
    // 権限を取得
    let authorityId = localStorage.getItem(
      ConstUtil.Common.STORAGE_KEY.AUTHORITY_ID
    );
    switch (authorityId) {
      // 配送業者
      case ConstUtil.Common.AUTHORITY_LIST.CONTRACTOR:
        return this.renderContractorHamburgerMenu();
      // ドライバー
      case ConstUtil.Common.AUTHORITY_LIST.DRIVER:
        return this.renderDriverHamburgerMenu();
      default:
        return (
          <div className="header-hamberger">
            <mobiscroll.HamburgerNav
              theme={ConstUtil.Common.THEME}
              lang={ConstUtil.Message.COMMON.ID401}
              onItemTap={this.clickHamburgerMenu}
            >
              {this.renderMyPageMenu()}
              {this.renderLogoutMenu()}
            </mobiscroll.HamburgerNav>
          </div>
        );
    }
  }

  /**
   * ヘッダーの参照取得
   *
   * @param {Object} node ノード情報
   * @returns
   * @memberof Header
   */
  getRefHeader(node) {
    if (_.isEmpty(node)) {
      return;
    }
    this.refHeader = node;
  }

  /**
   * 描画
   *
   * @returns {Object} 画面を構成する要素
   * @memberof Header
   */
  render() {
    let addClassName = '';
    // ログイン画面の場合
    if (this.props.location.hash === ConstUtil.Common.COMPONENT.LOGIN.URL) {
      addClassName = 'login-header';
    }
    return (
      <header
        className={`portal-header ${addClassName}`}
        ref={this.getRefHeader}
      >
        {this.renderSystemTitle()}
        {this.renderButtonArea()}
        {this.renderMenu()}
      </header>
    );
  }
}

Header.propTypes = {
  setHeight: PropTypes.func.isRequired,
  location: PropTypes.shape({
    hash: PropTypes.string.isRequired,
    state: PropTypes.object
  }),
  history: PropTypes.shape({ push: PropTypes.func })
};
export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/js/component/core/Header.jsx